import styled from 'styled-components'
import { useRepo } from 'querys/github'
import { P } from 'common/typography'


const UpdateStackStyled = styled.div`
  margin-bottom: 16px;
  a {
    color: var(--turquoise);
    cursor: pointer;
  }
`

function UpdateStack({ repo, name }) {
  const { data, isLoading } = useRepo(name)

  if (data && data?.topics?.length !== 0) {
    return (
      <UpdateStackStyled>
        <P>Ya puedes solicitar una revisión</P>
      </UpdateStackStyled>
    )
  }

  return (
    <UpdateStackStyled>
      <P>El repositorio carece de etiquetas o de descripción.</P>
      <a href={repo} target="_blank" rel="noopener noreferrer">Actualizar repositorio</a>
    </UpdateStackStyled>
  )
}

export default UpdateStack
